/**
 * Public display name of whoever performs a coupon check, shown in the
 * "Verification history" panel ("Checked by CouponSwift").
 *
 * This is the ONE place to change it. The owner is still deciding between
 * "CouponSwift" and a real person; never put an internal tool name here
 * (SwiftPilot, CouponChecker, ...) and never invent a person.
 */
export const VERIFIER_DISPLAY_NAME = "CouponSwift";
